module.exports = __webpack_public_path__ + "static/img/Round-05-2009.84006ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-05-2009.jpg
// module id = 8iRe
// module chunks = 0